import React, { useEffect, useState } from 'react';
import classes from './ConnectPlusHome.module.scss';
import lsConfig from 'utils/global-config';
import {
  languageJSONList,
  ENGLISH_LANGUAGE_CODE,
  CZECH_LANGUAGE_CODE,
  DUTCH_LANGUAGE_CODE,
  FINNISH_LANGUAGE_CODE,
  FRENCH_LANGUAGE_CODE,
  GERMAN_LANGUAGE_CODE,
  ITALIAN_LANGUAGE_CODE,
  JAPANESE_LANGUAGE_CODE,
  KOREAN_LANGUAGE_CODE,
  NORWEGIAN_LANGUAGE_CODE,
  POLISH_LANGUAGE_CODE,
  PORTUGUESE_LANGUAGE_CODE,
  SPANISH_LANGUAGE_CODE,
  SWEDISH_LANGUAGE_CODE,
  DARK_MODE,
  LIGHT_MODE
} from '../../constants/Gems';
import { getCurrentLanguage } from 'utils/guest-utils';
import lifesizeEnghouseDark from '../../assets/images/Enghouse_lifesize_white.svg';
import lifesizeEnghouseLight from '../../assets/images/Enghouse_lifesize_color.svg';
import SunIcon from '../../assets/images/sun.png';
import MoonIcon from '../../assets/images/moon.png';

const ConnectPlusHome = () => {
  const [currentLanguage, setCurrentLanguage] = useState(ENGLISH_LANGUAGE_CODE);
  const [languageJSON, setLanugageJSON] = useState(languageJSONList[ENGLISH_LANGUAGE_CODE]);
  const [theme, setTheme] = useState(LIGHT_MODE);

  const handleButtonClick = (url) => {
    lsConfig.skipOnBeforeUnload();
    window.open(url, '_self');
  };

  const setPageLanguage = (currentLanguage) => {
    const selectElement = document.getElementById('language');
    switch (currentLanguage) {
      case CZECH_LANGUAGE_CODE: {
        selectElement.value = CZECH_LANGUAGE_CODE;
        setCurrentLanguage(CZECH_LANGUAGE_CODE);
        break;
      }
      case DUTCH_LANGUAGE_CODE: {
        selectElement.value = DUTCH_LANGUAGE_CODE;
        setCurrentLanguage(DUTCH_LANGUAGE_CODE);
        break;
      }
      case FINNISH_LANGUAGE_CODE: {
        selectElement.value = FINNISH_LANGUAGE_CODE;
        setCurrentLanguage(FINNISH_LANGUAGE_CODE);
        break;
      }
      case FRENCH_LANGUAGE_CODE: {
        selectElement.value = FRENCH_LANGUAGE_CODE;
        setCurrentLanguage(FRENCH_LANGUAGE_CODE);
        break;
      }
      case GERMAN_LANGUAGE_CODE: {
        selectElement.value = GERMAN_LANGUAGE_CODE;
        setCurrentLanguage(GERMAN_LANGUAGE_CODE);
        break;
      }
      case ITALIAN_LANGUAGE_CODE: {
        selectElement.value = ITALIAN_LANGUAGE_CODE;
        setCurrentLanguage(ITALIAN_LANGUAGE_CODE);
        break;
      }
      case JAPANESE_LANGUAGE_CODE: {
        selectElement.value = JAPANESE_LANGUAGE_CODE;
        setCurrentLanguage(JAPANESE_LANGUAGE_CODE);
        break;
      }
      case KOREAN_LANGUAGE_CODE: {
        selectElement.value = KOREAN_LANGUAGE_CODE;
        setCurrentLanguage(KOREAN_LANGUAGE_CODE);
        break;
      }
      case NORWEGIAN_LANGUAGE_CODE: {
        selectElement.value = NORWEGIAN_LANGUAGE_CODE;
        setCurrentLanguage(NORWEGIAN_LANGUAGE_CODE);
        break;
      }
      case POLISH_LANGUAGE_CODE: {
        selectElement.value = POLISH_LANGUAGE_CODE;
        setCurrentLanguage(POLISH_LANGUAGE_CODE);
        break;
      }
      case PORTUGUESE_LANGUAGE_CODE: {
        selectElement.value = PORTUGUESE_LANGUAGE_CODE;
        setCurrentLanguage(PORTUGUESE_LANGUAGE_CODE);
        break;
      }
      case SPANISH_LANGUAGE_CODE: {
        selectElement.value = SPANISH_LANGUAGE_CODE;
        setCurrentLanguage(SPANISH_LANGUAGE_CODE);
        break;
      }
      case SWEDISH_LANGUAGE_CODE: {
        selectElement.value = SWEDISH_LANGUAGE_CODE;
        setCurrentLanguage(SWEDISH_LANGUAGE_CODE);
        break;
      }
      default: {
        selectElement.value = ENGLISH_LANGUAGE_CODE;
        setCurrentLanguage(ENGLISH_LANGUAGE_CODE);
        break;
      }
    }
  };

  useEffect(() => {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme(DARK_MODE);
    } else {
      setTheme(LIGHT_MODE);
    }

    document.title = 'Connect Plus+ Meeting Solution Selection - Lifesize';

    const currentLanguage = getCurrentLanguage();
    setPageLanguage(currentLanguage);

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
      const newColorScheme = event.matches ? DARK_MODE : LIGHT_MODE;
      setTheme(newColorScheme);
    });
  }, []);

  useEffect(() => {
    if (!!currentLanguage) {
      setLanugageJSON(languageJSONList[currentLanguage]);
    }
  }, [currentLanguage]);

  useEffect(() => {
    // window.onbeforeunload = null;
    lsConfig.skipOnBeforeUnload();
  }, [theme, currentLanguage]);

  return (
    <div className={classes.containerWrapper}>
      <div className={theme === DARK_MODE ? classes.container : classes.lightContainer} id="light">
        <div className={classes.headerContainer}>
          <img
            src={theme === DARK_MODE ? lifesizeEnghouseDark : lifesizeEnghouseLight}
            alt="lifesize - Enghouse-yritys"
            className={classes.logo}
          ></img>
          <select
            id="language"
            className={theme === DARK_MODE ? classes.select : classes.lightSelect}
            defaultValue={currentLanguage}
            onChange={(value) => {
              setCurrentLanguage(document.getElementById('language').value);
            }}
          >
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={CZECH_LANGUAGE_CODE}
            >
              Czech
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={DUTCH_LANGUAGE_CODE}
            >
              Dutch
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={ENGLISH_LANGUAGE_CODE}
            >
              English
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={FINNISH_LANGUAGE_CODE}
            >
              Finnish
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={FRENCH_LANGUAGE_CODE}
            >
              French
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={GERMAN_LANGUAGE_CODE}
            >
              German
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={ITALIAN_LANGUAGE_CODE}
            >
              Italian
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={JAPANESE_LANGUAGE_CODE}
            >
              Japanese
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={KOREAN_LANGUAGE_CODE}
            >
              Korean
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={NORWEGIAN_LANGUAGE_CODE}
            >
              Norwegian
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={POLISH_LANGUAGE_CODE}
            >
              Polish
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={PORTUGUESE_LANGUAGE_CODE}
            >
              Portuguese
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={SPANISH_LANGUAGE_CODE}
            >
              Spanish
            </option>
            <option
              className={theme === DARK_MODE ? classes.selectOptionDark : classes.selectOptionLight}
              value={SWEDISH_LANGUAGE_CODE}
            >
              Swedish
            </option>
          </select>
        </div>
        <div className={classes.buttonContainer}>
          <div className={classes.buttonHeadingWrapper}>
            <div className={theme === DARK_MODE ? classes.buttonHeading : classes.lightButtonHeading}>
              {languageJSON.select_meeting}
            </div>
          </div>
          <div className={classes.buttonContainerOne}>
            <button
              type="button"
              className={classes.buttonOne}
              onClick={() => handleButtonClick('https://www.microsoft.com/microsoft-teams/join-a-meeting')}
            >
              <div className={classes.text}>
                {languageJSON.join + ' ' + languageJSON.microsoft_teams}
                <div className={classes.tradeMark}>{String.fromCharCode(0x000ae)}</div>
                {languageJSON.guest}
              </div>
            </button>
            <div className={classes.spacer} />
            <button
              className={classes.buttonOne}
              kind="primary"
              disabled={false}
              onClick={() => handleButtonClick('https://www.microsoft.com/microsoft-teams/log-in')}
            >
              <div className={classes.text}>
                {languageJSON.login_to + ' ' + languageJSON.microsoft_teams}
                <div className={classes.tradeMark}>{String.fromCharCode(0x000ae)}</div>
                {languageJSON.account}
              </div>
            </button>
          </div>
          <div className={classes.buttonContainerTwo}>
            <button
              className={classes.buttonTwo}
              kind="primary"
              disabled={false}
              onClick={() => handleButtonClick('https://web.webex.com/join-meeting')}
            >
              <div className={classes.text}>
                {languageJSON.cisco_webex}
                <div className={classes.tradeMark}>{String.fromCharCode(0x000ae)}</div>
              </div>
            </button>
            <div className={classes.spacer} />
            <button
              className={classes.buttonTwo}
              kind="primary"
              disabled={false}
              onClick={() => handleButtonClick('https://apps.google.com/meet/')}
            >
              <div className={classes.text}>
                {languageJSON.google_meet}
                <div className={classes.tradeMark}>{String.fromCharCode(0x02122)}</div>
              </div>
            </button>
            <div className={classes.spacer} />
            <button
              className={classes.buttonTwo}
              kind="primary"
              disabled={false}
              onClick={() => handleButtonClick('https://pwa.zoom.us/wc/')}
            >
              <div className={classes.text}>
                {languageJSON.zoom}
                <div className={classes.tradeMark}>{String.fromCharCode(0x000ae)}</div>
              </div>
            </button>
          </div>
          <div className={classes.tradmarkTextContainer}>
            <div className={theme === DARK_MODE ? classes.tradmarkText : classes.lightTradmarkText}>
              {languageJSON.trade_mark}
            </div>
          </div>
        </div>
        <img
          className={classes.themeButton}
          src={theme === DARK_MODE ? MoonIcon : SunIcon}
          alt=""
          onClick={() => {
            if (theme === DARK_MODE) {
              setTheme(LIGHT_MODE);
              document.documentElement.setAttribute('data-theme', 'light');
            } else {
              setTheme(DARK_MODE);
              document.documentElement.setAttribute('data-theme', 'light');
            }
          }}
        />
      </div>
    </div>
  );
};

export default ConnectPlusHome;
